import { ObservableRequestService } from 'app/services/observable-request.service';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import 'rxjs/add/operator/map';

import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { GlobalValuesService } from 'app/services/global-values.service';
import { SidebarService } from 'app/services/sidebar.service';

import { UserIdleService } from 'app/services/user-idle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [ObservableRequestService]
})

export class AppComponent implements OnInit {
  isSidebarOpen = false;

  constructor(private userIdleService: UserIdleService,
    private globalValuesService: GlobalValuesService,
    private sidebarService: SidebarService,
    private router: Router,
    private trackingService: TrackingService,
    private viewContainerRef: ViewContainerRef) {

    this.setupGoogleAnalytics();
    this.userIdleService.viewContainerRef = viewContainerRef;
  }

  ngOnInit() {
    this.sidebarService
      .onIsSidebarOpenChanged()
      .subscribe(flag => { this.isSidebarOpen = flag; });
  }

  setupGoogleAnalytics() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.trackingService.sendPageview(event.urlAfterRedirects);
      }
    });
  }
}

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */

(function detectIE() {
  var ua = window.navigator.userAgent;

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    var ieV = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    document.querySelector('body').className += ' ie11';
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // IE 12 (aka Edge) => return version number
    var ieV = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    document.querySelector('body').className += ' edge';
  }

  // other browser
  return false;
})();



// WEBPACK FOOTER //
// ./src/app/app.component.ts